import { Box } from '@chakra-ui/react';

import { TextBold, TextMedium, TextRegular } from 'UiKit/typography';
import formatCurrency from 'Helper/formatCurrency';
import { Condition, Iteration } from 'Component/others';

import styles from './styles.module.css';

const ColumnPricePromo = ({ value }) => {
  return (
    <Box className={styles['column-price-promo__container']}>
      <Condition
        statement={value && value.length > 0}
        fallback={
          <Box className={styles['column-price-promo__box--item']}>
            <TextRegular className={styles['column-price-promo__text--empty']}>-</TextRegular>
          </Box>
        }
      >
        <Iteration
          items={value.filter((_, index) => index < 2)}
          render={(product, index) => {
            const isFirstColumn = index === 0 && value?.length > 1;
            const isLastColumn = index === 1;
            return (
              <Box
                key={index}
                className={`${styles['column-price-promo__box']}
                 ${isFirstColumn && styles['column-price-promo__box--first']} 
                 ${isLastColumn && styles['column-price-promo__box--last']}`}
              >
                <Box className={styles['column-price-promo__box--item']}>
                  <TextBold className={styles['column-price-promo__text--promotion']}>{formatCurrency(product.promotionPrice)}</TextBold>
                  <TextMedium className={styles['column-price-promo__text--normal']}>{formatCurrency(product.normalPrice)}</TextMedium>
                  <TextMedium className={styles['column-price-promo__text--discount']}>{product.discountPercentage}%</TextMedium>
                </Box>
              </Box>
            );
          }}
        />
      </Condition>
    </Box>
  );
};

export default ColumnPricePromo;
